import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { FeatureFlag } from 'app/modules/main/models/feature-flag';
import { UserSettings } from 'app/modules/main/models/user-settings';
import { UserSettingsState } from 'app/modules/main/store/user-settings/user-settings.state';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserSettingsSelectors {

  static readonly FEATURE = 'UserSettings';

  private readonly feature = createFeatureSelector<UserSettingsState>(
    UserSettingsSelectors.FEATURE
  );

  private readonly userSettings = createSelector(
    this.feature,
    (state: UserSettingsState) => state.userSettings
  );

  private readonly userSettingsLoaded = createSelector(
    this.feature,
    (state: UserSettingsState) => state.userSettingsLoaded
  );

  constructor(
    private readonly store: Store<UserSettingsState>
  ) {
  }

  public haveUserSettingsLoaded(): Observable<boolean> {
    return this.store.select(this.userSettingsLoaded);
  }

  public onUserSettingsLoaded(): Observable<boolean> {

    return this.haveUserSettingsLoaded()
      .pipe(filter(x => !!x));
  }

  public getUserSettings(): Observable<UserSettings> {

    return this.onUserSettingsLoaded()
      .pipe(switchMap(() => this.store.select(this.userSettings)));
  }

  public getFeatureFlags(): Observable<FeatureFlag[]> {

    return this.getUserSettings()
      .pipe(map(userSettings => userSettings.featureFlags));
  }

  public isFeatureEnabled(
    feature: string
  ): Observable<boolean> {

    return this.getFeatureFlags()
      .pipe(
        map(featureFlags =>
          featureFlags.some(
            (featureFlag) =>
              featureFlag.enabled &&
              featureFlag.feature === feature
          )
        ),
        shareReplay(1),
      );
  }

}
